import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { adminOperatorsApi } from "./api";

export const operatorKeys = {
  all: ["admin-operators"] as const,
  list: () => [...operatorKeys.all, "list"] as const,
};

export function useAdminOperators() {
  return useQuery({
    queryKey: operatorKeys.list(),
    queryFn: () => adminOperatorsApi.list(),
  });
}

export function useCreateOperator() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: Parameters<typeof adminOperatorsApi.create>[0]) =>
      adminOperatorsApi.create(body),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: operatorKeys.list() });
      // The login selector fetches a separate endpoint (/api/auth/operators),
      // so we don't need to invalidate anything else here.
    },
  });
}

export function useUpdateOperator() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, body }: { id: number; body: Parameters<typeof adminOperatorsApi.patch>[1] }) =>
      adminOperatorsApi.patch(id, body),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: operatorKeys.list() });
    },
  });
}

export function useDeleteOperator() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => adminOperatorsApi.remove(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: operatorKeys.list() });
    },
  });
}